// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"190":"ee44dedb","221":"c6fc1138","940":"e5992944"}[chunkId] + ".css";
};